import { Box, Grid, Typography } from '@mui/material';
import type { ReactElement } from 'react';

import Enums from '@core/types/api/Enums';
import type { Tenant } from '@core/types/api/Tenant/Tenant';
import { FormatLinkCell } from '@web/components/DataTable/components/SlabTableRowCells';
import { DataTable } from '@web/components/DataTable/DataTable';
import type { ColumnConfig } from '@web/components/DataTable/TableDataModel';
import { useApiTableDataWithoutAggregations } from '@web/components/DataTable/useApiTableData';
import { Page } from '@web/components/Page/Page';

import { AuthOverride } from './AuthOverride';

const tenantColumns: ColumnConfig<Tenant>[] = [
  {
    id: 'name',
    label: 'Name',
    type: 'string',
    isDisplayed: true,
    formatValueForWeb: (label, row) =>
      FormatLinkCell({ label, link: `/_slabstack_staff/${row.id}` }),
  },
  {
    id: 'id',
    label: 'ID',
    type: 'string',
    isDisplayed: true,
  },
];

export const TenantList = (): ReactElement => {
  const tableModel = useApiTableDataWithoutAggregations({
    rowsRouteKey: 'GET tenants as admin',
    extractRows: (list) => list.items,
    rowsPathParams: {},
    initialSortBy: {
      direction: Enums.SortDirection.Ascending,
      name: 'name',
    },
    makeColumnConfigs: () => [...tenantColumns],
  });

  return (
    <Page title='Tenants' pathMap={{ '/_slabstack_staff': 'Admin Portal' }}>
      <Box display='flex' justifyContent='space-between' paddingBottom='3.5rem'>
        <Typography variant='h1'>Tenants</Typography>
      </Box>
      <Grid container spacing={2}>
        <Grid item xs={7}>
          <DataTable tableName='tenants' tableModel={tableModel} />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <AuthOverride />
        </Grid>
      </Grid>
    </Page>
  );
};
